import { Avatar, Box } from "@mui/material";
import { getIconColor, getIconName, stringAvatar } from "../../utils/helpers";

const OrganizationLogo = ({
  logoType,
  iconName,
  iconColor,
  logoUrl,
  name,
  width = 40,
  height = 40,
  fontSize = "1.2rem",
}) => {
  if (logoType === "custom" && logoUrl) {
    return (
      <Box
        width={width}
        height={height}
        borderRadius="4px"
        overflow="hidden"
        flexShrink={0}
      >
        <img
          width="100%"
          height="100%"
          src={logoUrl}
          alt={name || "organization logo"}
        />
      </Box>
    );
  }

  if (!iconName || iconName === "avatar_icon") {
    return (
      <Avatar
        variant="rounded"
        sx={{
          background: getIconColor(iconColor),
          width,
          height,
          fontSize,
          flexShrink: 0,
        }}
        {...stringAvatar(name)}
      />
    );
  }

  return (
    <Box
      width={width}
      height={height}
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={{ background: getIconColor(iconColor) }}
      borderRadius="4px"
      flexShrink={0}
    >
      {getIconName(iconName)}
    </Box>
  );
};

export default OrganizationLogo;
